// this mock was separated from mocks.ts to avoid a circular dependency.
// actions -> mocks -> fastshift-table -> analytics hooks -> state reducer -> actions
// once actions.tsx no longer consumes this mock, this file can be merged back into mocks.ts

import { type FastShiftState } from "./reducer";

export const mockCustomerDomainEngagementProductionLinks: NonNullable<
    FastShiftState["customerDomainEngagement"]["data"]
> = {
    engagementProjects: [
        {
            projectName: "SXP",
            projectIcon:
                "https://hello.atlassian.net/rest/api/2/universal_avatar/view/type/project/avatar/35308",
            projectKey: "SXP",
            projectUrl: "https://hello.atlassian.net/browse/SXP", // this doesn't work
            boards: [
                {
                    boardName: "SXP Scrum",
                    boardId: "9225",
                    embeds: [
                        {
                            url: "https://hello.jira.atlassian.cloud/jira/software/c/projects/SXP/boards/9225/timeline",
                            type: "TIMELINE"
                        },
                        {
                            url: "https://hello.jira.atlassian.cloud/jira/software/c/projects/SXP/boards/9225/calendar",
                            type: "CALENDAR"
                        }
                    ]
                },
                {
                    boardName: "SXP Kanban",
                    boardId: "15730",
                    embeds: [
                        {
                            url: "https://hello.jira.atlassian.cloud/jira/software/c/projects/SXP/boards/15730/timeline",
                            type: "TIMELINE"
                        },
                        {
                            url: "https://hello.jira.atlassian.cloud/jira/software/c/projects/SXP/boards/15730/calendar",
                            type: "CALENDAR"
                        }
                    ]
                }
            ]
        },
        {
            projectName: "Engagement",
            projectIcon:
                "https://as-a-team.atlassian.net/rest/api/2/universal_avatar/view/type/project/avatar/12409?size=xlarge",
            projectKey: "ENGAGE",
            projectUrl: "https://as-a-team.atlassian.net/browse/ENGAGE", // this does work
            boards: [
                {
                    boardName: "Engagement",
                    boardId: "mock-board-id-2",
                    embeds: [
                        {
                            url: "https://as-a-team.atlassian.net/jira/core/projects/ENGAGE/timeline",
                            type: "TIMELINE"
                        },
                        {
                            url: "https://as-a-team.atlassian.net/jira/core/projects/ENGAGE/calendar",
                            type: "CALENDAR"
                        }
                    ]
                }
            ]
        },
        {
            // as-a-team live
            projectName: "Accenture",
            projectIcon:
                "https://as-a-team.atlassian.net/rest/api/2/universal_avatar/view/type/project/avatar/12421",
            projectKey: "ACNCIO",
            projectUrl: "https://as-a-team.atlassian.net/browse/ACNCIO",
            boards: [
                {
                    boardName: "ACNCIO Board",
                    boardId: "mock-board-id-3",
                    embeds: [
                        {
                            url: "https://as-a-team.atlassian.net/jira/software/c/projects/ACNCIO/boards/607/timeline",
                            type: "TIMELINE"
                        },
                        {
                            url: "https://as-a-team.atlassian.net/jira/software/c/projects/ACNCIO/boards/607/calendar",
                            type: "CALENDAR"
                        }
                    ]
                }
            ]
        },
        {
            // advanced roadmap
            projectName: "Sandisk FS Migration timeline",
            projectIcon: "", // there is no icon
            projectKey: "894", // no id, just number
            projectUrl:
                "https://as-a-team.atlassian.net/jira/plans/894/scenarios/895/summary",
            boards: [
                {
                    boardName: "Sandisk FS Migration timeline",
                    boardId: "mock-board-id-999",
                    embeds: [
                        {
                            url: "https://as-a-team.atlassian.net/jira/plans/894/scenarios/895/timeline?vid=1160",
                            type: "TIMELINE"
                        },
                        {
                            url: "https://as-a-team.atlassian.net/jira/plans/894/scenarios/895/calendar",
                            type: "CALENDAR"
                        }
                    ]
                }
            ]
        }
    ],
    engagementSpaces: [
        {
            spaceKey: "ACCENTURE",
            spaceUrl:
                "https://as-a-team.atlassian.net/wiki/spaces/ACCENTURE/overview"
        }
    ]
};
